module.exports = __webpack_public_path__ + "static/img/areaB_6.cd3e02b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_6.png
// module id = 1269
// module chunks = 1